import React from "react"
import "../../style/loading.css"

export default function Loading() {
    return (
        <section className="h-screen w-screen bg-white overflow-hidden z-[999] absolute top-0 left-0">
            <div className="flex flex-row gap-2 items-center justify-center h-full w-full">
                <div className="w-4 h-4 rounded-full bg-primary animate-bounce"></div>
                <div className="w-4 h-4 rounded-full bg-primary animate-bounce [animation-delay:-.3s]"></div>
                <div className="w-4 h-4 rounded-full bg-primary animate-bounce [animation-delay:-.5s]"></div>
            </div>
        </section>
    )
}
